import { render } from "./p-checkbox.vue?vue&type=template&id=7f838a5a&scoped=true"
import script from "./p-checkbox.vue?vue&type=script&lang=js"
export * from "./p-checkbox.vue?vue&type=script&lang=js"

import "./p-checkbox.vue?vue&type=style&index=0&id=7f838a5a&scoped=true&lang=scss"
import "./p-checkbox.vue?vue&type=style&index=1&id=7f838a5a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f838a5a"]])

export default __exports__